import { GetStaticProps } from "next";
import Head from "next/head";
import SumoLanding from "../../components/Templates/SumoLanding";
import { sumoPracticeProductsIds } from "../../constants/products";
import { addApolloState, initializeApollo } from "../../graphql/apolloClient";
import { Iso639 } from "../../graphql/operations";
import {
  GET_PRODUCT_REVIEWS,
  flattenReviews,
} from "../../utils/queries/LandingPageReviews";

export default function SumoJapan({ result }) {
  const { products } = result.data;
  const { records } = products;

  const flattenedReviews = flattenReviews(records);

  const jsonLd = [
    {
      "@context": "http://schema.org",
      "@type": "Product",
      name: `Best 5 Sumo Tournament & Morning Practice Tours in Tokyo`,
      description:
        "Watch the Sumo grand tournament and Sumo morning training in Tokyo. MagicalTrip also offers various types of Sumo tours in Ryogoku and Skytree area. Dive into the Sumo world.",
      image: {
        url: `https://res.cloudinary.com/dbm1qiew0/image/upload/e_art:red_rock/q_auto,f_auto,dpr_2.0,h_150,c_scale/v1700468660/products/3e954323-fe3f-411e-955e-ca39b760883c/images/5e93fa12-6af5-4b76-93ce-0a7a4e02a2c8.jpg`,
      },
      url: `https://www.magical-trip.com/sumo-japan`,
      productID: "sumo-japan",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.97",
        reviewCount:
          flattenedReviews.totalRecords > 0
            ? flattenedReviews.totalRecords
            : 96,
      },
    },
  ];
  return (
    <>
      <Head>
        <meta
          name="description"
          content="Watch the Sumo grand tournament and Sumo morning training in Tokyo. MagicalTrip also offers various types of Sumo tours in Ryogoku and Skytree area. Dive into the Sumo world."
        />
        <meta
          name="keywords"
          content="tokyo sumo, sumo experience, sumo japan, sumo training, sumo practice, guide, japan tours"
        />
        <title>Best 5 Sumo Tournament & Morning Practice Tours in Tokyo</title>
        <script
          key="json-ld"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Head>
      <SumoLanding reviews={flattenedReviews} />
    </>
  );
}

const revalidate = process.env.ENVIRONMENT == "production" ? 3600 : 60;
export const getStaticProps: GetStaticProps = async () => {
  try {
    const apolloClient = initializeApollo();
    const result = await apolloClient.query({
      query: GET_PRODUCT_REVIEWS,
      variables: {
        limit: 5,
        lang: Iso639.En,
        input: {
          ids: [
            ...sumoPracticeProductsIds,
            "9374c341-6d87-4064-85f2-80bdb3edfb6b",
            "3e954323-fe3f-411e-955e-ca39b760883c",
            "eb27e9cc-6f1f-4f15-847c-7c174f1e7045",
          ],
        },
      },
    });

    return addApolloState(apolloClient, {
      props: {
        result,
      },
      revalidate,
    });
  } catch {
    return {
      props: {
        result: {
          data: {
            products: {
              records: [],
            },
          },
        },
      },
      revalidate: 1,
    };
  }
};
